import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Tooltip,
  createMuiTheme,
  TextField,
} from "@material-ui/core";
import {
  ExpandLess,
  ExpandMore,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";
import { DeleteOutline } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { getCustomers } from "../../../../api/customer";
import {
  deleteOfferChapter,
  getOfferChaptersById,
  postOfferChapter,
  postOfferChapterNewRevision,
  reorderOfferChapter,
  updateOfferChapter,
} from "../../../../api/offerChapter";
import {
  getOfferHeaderByIdAndRevision,
  getOfferHeadersById,
  postOfferHeader,
  postOfferHeaderNewRevision,
  updateOfferHeader,
  updateOfferHeaderStatus,
} from "../../../../api/offerHeader";
import {
  deleteOfferPartida,
  getOfferPartidasById,
  postOfferPartida,
  postOfferPartidaNewRevision,
  postOfferPartidaRevision,
  reorderOfferPartida,
  updateOfferPartida,
  importOfferPartidaDecomposition,
} from "../../../../api/offerPartida";
import {
  deleteOfferProduct,
  postOfferProduct,
  postOfferProductNewRevision,
  reorderOfferProduct,
  updateProductOriginal,
} from "../../../../api/offerProduct";
import { getOfferStatus } from "../../../../api/offerStatus";
import {
  getPartidaById,
  getPartidas,
  postPartida,
  updatePartida,
} from "../../../../api/partida";
import { getPartidaCategories } from "../../../../api/partidaCategory";
import { getProducts } from "../../../../api/product";
import { getProductFamilies } from "../../../../api/productFamily";
import { getProductTypes } from "../../../../api/productType";
import { OFFER_STATUS, ROLES, TIPO_PARTIDA } from "../../../../utils/constants";
import { formatInstallationTime, generatePDF, generateExcel } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { isAvailableToOfferCustomer, isSpecificToOfferCustomer } from "../../../../utils/offerPartidaSelection";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import ChangeOfferProductMultiplicableDialog from "../../../components/dialogs/ChangeOfferProductMultiplicableDialog";
import ChangeOfferProductTimeDialog from "../../../components/dialogs/ChangeOfferProductTimeDialog";
import ChangeOfferProductUnitsDialog from "../../../components/dialogs/ChangeOfferProductUnitsDialog";
import EditOfferHeaderDialog from "../../../components/dialogs/EditOfferHeaderDialog";
import EditOfferPartidaDialog from "../../../components/dialogs/EditOfferPartidaDialog";
import EditOfferProductDialog from "../../../components/dialogs/EditOfferProductDialog";
import LoadingDialog from "../../../components/dialogs/LoadingDialog";
import OfferChapterDialog from "../../../components/dialogs/OfferChapterDialog";
import PartidaTableDialog from "../../../components/dialogs/PartidaTableDialog";
import ProductSelectTableDialog from "../../../components/dialogs/ProductSelectTableDialog";
import ChangeOfferPartidaPositionDialog from "../../../components/dialogs/ChangeOfferPartidaPositionDialog";
import { offerStatusFormatter } from "../../../components/tables/table";
import { useSkeleton } from "../../../hooks/useSkeleton";
import GuardarPlantillaPartidaDialog from "../../../components/dialogs/GuardarPlantillaPartidaDialog";
import PartidaRevisionTableDialog from "../../../components/dialogs/PartidaRevisionTableDialog";
import { getIVAs } from "../../../../api/iva";
import { getProductMarcas } from "../../../../api/productMarca";
import { getOfferDefaultsConfig } from "../../../../api/generalConfig";
import { deleteOfferMaterialGroup, getMaterialGroups, postOfferMaterialGroup, updateOfferMaterialGroup } from "../../../../api/materialGroup";
import MaterialGroupSelectDialog from "../../../components/dialogs/MaterialGroupSelectDialog";
// import { DEFAULT_CABECERA, DEFAULT_CONDICIONES } from "app/constants/ofertaDefaults";


// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

const IOfferHeader = {
  id: null,
  revision_num: 0,
  num_oferta: null,
  cliente_id: null,
  localizacion: null,
  referencia: null,
  estado_id: OFFER_STATUS.BORRADOR,

  def_margen_material: 0,
  def_margen_m_obra: 0,
  def_margen_subcontrata: 0,

  def_comisiones: 0,
  def_coste_hora_m_obra: 0,
  def_trabajadores_asignados: 0,

  calc_tiempo_jornadas: null,
  calc_tiempo_horas: null,
  calc_m_obra_coste: null,
  calc_m_obra_pvp: null,
  calc_m_obra_pvp_final: null,
  calc_subcontrata_coste: null,
  calc_subcontrata_pvp: null,
  calc_subcontrata_pvp_final: null,
  calc_materiales_coste: null,
  calc_materiales_pvp: null,
  calc_materiales_pvp_final: null,
  calc_total_coste: null,
  calc_total_pvp: null,
  calc_total_pvp_final: null,

  /** @type {[IOfferChapter]} */
  capitulos: [],
};

const IOfferChapter = {
  oferta_id: null,
  revision_num: 0,
  capitulo_id: null,
  ordinal: null,
  partida_categoria_id: null,
  titulo: null,
  titulo_efectivo: null,
  total_precio: null,
  total_precio_final: null,

  /** @type {[IOfferPartida]} */
  partidas: [],
};

const getOfferChapterTitle = (chapter) =>
  String(
    chapter?.titulo_efectivo ||
      chapter?.titulo ||
      chapter?.partida_categoria?.descripcion ||
      "Capítulo"
  ).trim();

const IOfferPartida = {
  oferta_id: null,
  revision_num: 0,
  capitulo_id: null,
  partida_id: null,
  ordinal: null,
  plantilla_partida_original_id: null,
  referencia: null,
  descripcion: null,
  concepto: null,
  categoria_id: null,
  unidades: null,
  precio_unitario: null,
  precio_unitario_final: null,
  precio_total: null,
  precio_total_final: null,

  tiempo_total: 0,
  mano_obra_coste: 0,
  mano_obra_venta: 0,
  mano_de_obra_venta_final: 0,
  materiales_coste: 0,
  materiales_venta: 0,
  materiales_venta_final: 0,
  subcontrata_coste: 0,
  subcontrata_venta: 0,
  subcontrata_venta_final: 0,
  incremento_margen_subcontrata: null,
  def_tipo_impotacion_partida: 0,

  /** @type {[IOfferProduct]} */
  productos: [],
};

const IOfferProduct = {
  oferta_id: null,
  revision_num: 0,
  capitulo_id: null,
  partida_id: null,
  producto_id: null,
  ordinal: null,
  descripcion: null,
  referencia: null,
  plantilla_producto_original_id: null,

  tipo_producto_id: null,
  tipo_unidad_id: null,
  def_unidades: null,
  def_factor: null,
  def_precio_compra: null,
  def_descuento_proveedor: null,
  def_tiempo_mano_de_obra: null,

  calc_precio_hora: null,
  calc_mano_de_obra_coste: null,
  calc_mano_de_obra_venta: null,
  calc_mano_de_obra_venta_final: null,
  calc_materiales_coste: null,

  calc_materiales_venta: null,
  calc_materiales_venta_final: null,
  calc_subcontrata_coste: null,
  calc_subcontrata_venta: null,
  calc_subcontrata_venta_final: null,
  calc_total_coste: null,
  calc_total_venta: null,
  calc_total_venta_final: null,

  // Modificaciones FerBCN 25/02/2026
  // Imputaciones de material y tiempos en subcontrata mixta
  imputar_tiempo_a_mano_de_obra_interna: false,
  imputar_material_a_subcontrata: false,
};

function getEmptyOfferHeader() {
  return { ...IOfferHeader };
}

function getEmptyOfferChapter() {
  return { ...IOfferChapter };
}

function getEmptyOfferPartida() {
  return { ...IOfferPartida };
}

function getEmptyOfferProduct() {
  return { ...IOfferProduct };
}

function expandSingleItem(setter, itemId) {
  setter(itemId ? [itemId] : []);
}

function getFinalAmount(finalValue, baseValue) {
  return finalValue ?? baseValue ?? 0;
}

function formatCurrencyDisplay(value) {
  return Number(value ?? 0).toLocaleString("es-ES", {
    style: "currency",
    currency: "EUR",
  });
}

// Modificaciones FerBCN 25/02/2026
// Imputaciones de material y tiempos en subcontrata mixta
function normalizeOfferProductFlags(offerProduct, isSubcontrataMixta) {
  return {
    ...offerProduct,
    imputar_tiempo_a_mano_de_obra_interna: isSubcontrataMixta
      ? (offerProduct?.imputar_tiempo_a_mano_de_obra_interna ?? false)
      : false,
    imputar_material_a_subcontrata: isSubcontrataMixta
      ? (offerProduct?.imputar_material_a_subcontrata ?? false)
      : false,
  };
}


function offerPartidaTypeFormatter(offerPartidaType) {
  const type = TIPO_PARTIDA.find((x) => x.value === offerPartidaType);
  return (
    <div
      className={`p-2 text-white mr-2`}
      style={{ backgroundColor: type.color, borderRadius: "0.42rem" }}
    >
      {type?.label?.toUpperCase()}
    </div>
  );
}

export default function EditOffersPage() {
  const [offerHeader, setOfferHeader] = useState(getEmptyOfferHeader());
  const [customers, setCustomers] = useState([]);
  const [partidaCategories, setPartidaCategories] = useState([]);
  const [partidas, setPartidas] = useState([]);
  const [ivas, setIvas] = useState([]);
  const [guardarPlantillaPartida, setGuardarPlantillaPartida] = useState({});
  const [
    openGuardarPlantillaPartidaDialog,
    setOpenGuardarPlantillaPartidaDialog,
  ] = useState(false);
  const [guardarPlantillaProducto, setGuardarPlantillaProducto] = useState({});
  const [products, setProducts] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [productFamilies, setProductFamilies] = useState([]);
  const [productMarcas, setProductMarcas] = useState([]);
  const [materialGroups, setMaterialGroups] = useState([]);
  const [offerStatus, setOfferStatus] = useState([]);

  const [openEditOfferHeaderDialog, setOpenEditOfferHeaderDialog] = useState(
    false
  );
  const [openPartidaCategoryDialog, setOpenPartidaCategoryDialog] = useState(
    false
  );
  const [chapterToEdit, setChapterToEdit] = useState(null);
  const [
    openPartidaRevisionTableDialog,
    setOpenPartidaRevisionTableDialog,
  ] = useState(false);
  const [openPartidaTableDialog, setOpenPartidaTableDialog] = useState(false);
  const [openProductTableDialog, setOpenProductTableDialog] = useState(false);
  const [openMaterialGroupDialog, setOpenMaterialGroupDialog] = useState(false);
  const [top, setTop] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);

  const offerHeaderId = useParams().id;
  const revisionNumber = useParams().revisionNumber;

  const [loading, setLoading] = useState(false);
  const [isDetailLoading, setIsDetailLoading] = useState(Boolean(offerHeaderId));
  const detailLoadingTimeoutRef = useRef(null);
  const mountedRef = useRef(true);
  const offerHeaderRequestIdRef = useRef(0);

  const history = useHistory();
  const location = useLocation();

  // Añadido para evitar que mantenga las páginas de partidas entre distintos capítulo 28/01/2026
  const clearPageParam = () => {
    const params = new URLSearchParams(location.search);
    console.log(params.toString());
    if (!params.has("page")) return;

    params.delete("page");
    const newSearch = params.toString();
    history.replace({
      pathname: location.pathname,
      search: newSearch ? `?${newSearch}` : "",
    });
  };


  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );
  const isOfferManager = loggedUser?.role?.rango === ROLES.GESTOR_OFERTAS;

  const handleBack = () => {
    const prevTablePage = location.state?.page;

    history.push(`/ofertas${prevTablePage ? "?page=" + prevTablePage : ""}`);
  };

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  function handleGetOfferHeader(offerHeaderId, revisionNumber, { preserveDetail = false } = {}) {
    if (!mountedRef.current) return;
    const requestId = ++offerHeaderRequestIdRef.current;
    if (!preserveDetail) setIsDetailLoading(true);
    if (!preserveDetail && detailLoadingTimeoutRef.current) {
      clearTimeout(detailLoadingTimeoutRef.current);
    }

    getOfferHeaderByIdAndRevision(
      offerHeaderId,
      revisionNumber,
      loggedUser?.accessToken
    )
      .then((res) => {
        if (!mountedRef.current || requestId !== offerHeaderRequestIdRef.current) return;
        if (res.status === 200) {
          setOfferHeader((currentOfferHeader) => ({ ...currentOfferHeader, ...res.data }));
          setLoading(false);
          disableLoadingData();

          // Dejamos que el navegador pinte primero la cabecera antes de montar
          // todas las partidas de una oferta grande.
          if (!preserveDetail) {
            detailLoadingTimeoutRef.current = setTimeout(() => {
              setIsDetailLoading(false);
              detailLoadingTimeoutRef.current = null;
            }, 50);
          }
        }
      })
      .catch((error) => {
        if (!mountedRef.current || requestId !== offerHeaderRequestIdRef.current) return;
        alertError({
          error: error,
          customMessage: "No se ha podido obtener la oferta.",
        });
        setLoading(false);
        setIsDetailLoading(false);
        if (!preserveDetail) {
          handleBack();
        }
      });
  }

  useEffect(() => () => {
    mountedRef.current = false;
    offerHeaderRequestIdRef.current += 1;
    if (detailLoadingTimeoutRef.current) {
      clearTimeout(detailLoadingTimeoutRef.current);
    }
  }, []);

  function updateOfferPartidaInState(updatedPartida) {
    if (!updatedPartida?.partida_id) {
      return;
    }

    setOfferHeader((currentOfferHeader) => ({
      ...currentOfferHeader,
      capitulos: (currentOfferHeader?.capitulos || []).map((chapter) => {
        if (chapter?.capitulo_id !== updatedPartida.capitulo_id) {
          return chapter;
        }

        return {
          ...chapter,
          partidas: (chapter?.partidas || [])
            .map((partida) =>
              partida?.partida_id === updatedPartida.partida_id
                ? updatedPartida
                : partida
            )
            .sort((a, b) => a.ordinal - b.ordinal),
        };
      }),
    }));

    setSelectedPartida((currentSelectedPartida) =>
      currentSelectedPartida?.partida_id === updatedPartida.partida_id
        ? updatedPartida
        : currentSelectedPartida
    );
  }

  useEffect(() => {
    let active = true;
    getProductMarcas(loggedUser?.accessToken)
      .then((res) => {
        if (!active) return;
        if (res.status === 200) {
          setProductMarcas(res.data);
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener las marcas de productos.",
        });
      });
    getProducts(loggedUser?.accessToken)
      .then((res) => {
        if (!active) return;
        if (res.status === 200) {
          setProducts(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener los productos.",
        });
        handleBack();
      });
    getMaterialGroups(loggedUser?.accessToken).then((res) => {
      if (active) setMaterialGroups(res.data);
    }).catch(() => {});
    getOfferStatus(loggedUser?.accessToken)
      .then((res) => {
        if (!active) return;
        if (res.status === 200) {
          setOfferStatus(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener los estados.",
        });
        handleBack();
      });
    getProductFamilies(loggedUser?.accessToken)
      .then((res) => {
        if (!active) return;
        if (res.status === 200) {
          setProductFamilies(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener las familias de productos.",
        });
        handleBack();
      });
    getIVAs(loggedUser?.accessToken)
      .then((res) => {
        if (!active) return;
        if (res.status === 200) {
          setIvas(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener las familias de productos.",
        });
        handleBack();
      });
    getProductTypes(loggedUser?.accessToken)
      .then((res) => {
        if (!active) return;
        if (res.status === 200) {
          setProductTypes(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener los tipos de productos.",
        });
        handleBack();
      });
    getCustomers(loggedUser?.accessToken)
      .then((res) => {
        if (!active) return;
        if (res.status === 200) {
          setCustomers(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener los clientes.",
        });
        handleBack();
      });
    getPartidaCategories(loggedUser?.accessToken)
      .then((res) => {
        if (!active) return;
        if (res.status === 200) {
          setPartidaCategories(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener los capítulos.",
        });
        handleBack();
      });
    getPartidas(loggedUser?.accessToken)
      .then((res) => {
        if (!active) return;
        if (res.status === 200) {
          setPartidas(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener las partidas.",
        });
        handleBack();
      });
    if (!offerHeaderId) {
      getOfferDefaultsConfig(loggedUser?.accessToken)
        .then((res) => {
          if (!active) return;
          if (res.status === 200) {
            setOfferHeader((currentOfferHeader) => ({
              ...currentOfferHeader,
              cabecera_descripcion: res.data?.cabecera_descripcion || "",
              pie_condiciones_venta: res.data?.pie_condiciones_venta || "",
            }));
          }
        })
        .catch((error) => {
          if (!active) return;
          alertError({
            error,
            customMessage: "No se ha podido obtener la configuración de la oferta.",
          });
        });
      disableLoadingData();
      return () => { active = false; };
    }
    handleGetOfferHeader(offerHeaderId, revisionNumber);
    return () => { active = false; };
  }, [offerHeaderId, disableLoadingData, history]);

  useEffect(() => {
    handleResize();

    function handleResize() {
      setWindowHeight(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isMaterial = (id) => {
    const productType = productTypes.find((x) => x.producto_tipo_id === id);
    return productType.es_material;
  };

  async function handleNuevaRevision() {
    setLoading(true);
    const newNumeroRevision = offerHeader.revision_num + 1;
    try {
      await postOfferHeaderNewRevision(
        offerHeader.id,
        offerHeader,
        loggedUser?.accessToken
      );

      for (const capitulo of offerHeader.capitulos) {
        try {
          await postOfferChapterNewRevision(
            capitulo.capitulo_id,
            capitulo,
            loggedUser?.accessToken
          );

          for (const partida of capitulo.partidas) {
            try {
              await postOfferPartidaNewRevision(
                partida.partida_id,
                partida,
                loggedUser?.accessToken
              );

              for (const producto of partida.productos) {
                try {
                  await postOfferProductNewRevision(
                    producto.producto_id,
                    producto,
                    loggedUser?.accessToken
                  );
                } catch (error) {
                  alertError({
                    error,
                    customMessage: "No se ha podido guardar el producto",
                  });
                  setLoading(false);
                  return;
                }
              }
            } catch (error) {
              alertError({
                error,
                customMessage: "No se ha podido guardar la partida",
              });
              setLoading(false);
              return;
            }
          }
        } catch (error) {
          alertError({
            error,
            customMessage: "No se ha podido crear el capítulo",
          });
          setLoading(false);
          return;
        }
      }
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido crear la oferta.",
      });
      setLoading(false);
      return;
    } finally {
      setLoading(false);
      history.push({
        pathname: `/ofertas`,
      });
    }
  }

  function calc_total_costes(
    mano_obra_coste,
    subcontrata_coste,
    materiales_coste
  ) {
    return mano_obra_coste + subcontrata_coste + materiales_coste;
  }

  useEffect(() => {
    // Skip if sticky is disabled or on initial render when we don't know about window height.
    if (windowHeight === 0) return;

    const headerElement = document.querySelector(".header");
    const subheaderElement = document.querySelector(".subheader");
    const headerMobileElement = document.querySelector(".header-mobile");
    let nextMarginTop = 0;

    // mobile header
    if (window.getComputedStyle(headerElement).height === "0px")
      nextMarginTop = headerMobileElement.offsetHeight;
    // desktop header
    else if (document.body.classList.contains("header-minimize-topbar"))
      // hardcoded minimized header height
      nextMarginTop = 60;
    else {
      // normal fixed header
      if (document.body.classList.contains("header-fixed"))
        nextMarginTop += headerElement.offsetHeight;

      if (document.body.classList.contains("subheader-fixed"))
        nextMarginTop += subheaderElement.offsetHeight;
    }
    setTop(nextMarginTop);
    // setTimeout(() => {
    //   const stickyModule = document.querySelector(".stickyModule").offsetHeight;
    //   if (stickyModule) {
    //     nextMarginTop += stickyModule;
    //   }

    //   setTop(nextMarginTop);
    // }, 1000);
  }, [windowHeight]);

  const styles = {
    position: "sticky",
    top: `${top}px`,
    zIndex: 100,
    backgroundColor: "white",
    paddingLeft: "30px",
    paddingRight: "30px",
  };

  function saveOffer() {
    setLoading(true);
    if (!offerHeader?.id) {
      postOfferHeader(offerHeader, loggedUser?.accessToken)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "¡Guardada!",
              customMessage: "Oferta guardada con éxito.",
            });
            handleGetOfferHeader(res.data?.id, res.data?.revision_num);
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se ha podido guardar la oferta.",
          });
        });
    } else {
      updateOfferHeader(offerHeader?.id, offerHeader, loggedUser?.accessToken)
        .then((res) => {
          if (res.status === 204) {
            alertSuccess({
              title: "¡Guardado!",
              customMessage: "Cambios guardados con éxito.",
            });
            handleGetOfferHeader(offerHeader?.id, offerHeader?.revision_num);
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se han podido guardar los cambios.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    setOfferHeader({ ...offerHeader, [element]: event.target.value });
  };

  async function handleSaveAsNewOriginalPartida(savedPartida) {
    if (!savedPartida?.id || !guardarPlantillaPartida?.partida_id) {
      return;
    }

    const updatedOfferPartida = {
      ...guardarPlantillaPartida,
      plantilla_partida_original_id: savedPartida.id,
      referencia:
        savedPartida?.referencia ?? guardarPlantillaPartida?.referencia,
      descripcion:
        savedPartida?.descripcion ?? guardarPlantillaPartida?.descripcion,
    };

    setLoading(true);

    try {
      await updateOfferPartida(
        updatedOfferPartida?.partida_id,
        updatedOfferPartida,
        loggedUser?.accessToken
      );

      handleGetOfferHeader(offerHeader?.id, offerHeader?.revision_num);
    } catch (error) {
      alertError({
        error,
        customMessage:
          "La nueva plantilla se ha guardado, pero no se ha podido actualizar la partida de la oferta.",
      });
      setLoading(false);
    }
  }

  const [expandedChapters, setExpandedChapters] = useState([]);
  const [expandedPartidas, setExpandedPartidas] = useState([]);
  const [expandedProducts, setExpandedProducts] = useState([]);
  const [dataPartidaRevisionTable, setDataPartidaRevisionTable] = useState([]);
  const [dataCabecerasRevisionTable, setDataCabecerasRevisionTable] = useState(
    []
  );
  const [dataCapitulosRevisionTable, setDataCapitulosRevisionTable] = useState(
    []
  );

  const [selectedChapter, setSelectedChapter] = useState(null);
  const [selectedPartida, setSelectedPartida] = useState(null);
  const [newlyInsertedPartida, setNewlyInsertedPartida] = useState(null);

  const [isVisible, setIsVisible] = useState(true);
  const divRef = useRef(null);

  const checkVisibility = () => {
    if (divRef.current) {
      const rect = divRef.current.getBoundingClientRect();
      // Comprueba si el div está dentro del viewport
      const isInViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= window.innerHeight &&
        rect.right <= window.innerWidth;

      setIsVisible(isInViewport);
    }
  };

  useEffect(() => {
    // Agregar el evento de scroll
    window.addEventListener("scroll", checkVisibility);
    // Comprobar la visibilidad inicial
    checkVisibility();

    return () => {
      // Limpiar el evento de scroll
      window.removeEventListener("scroll", checkVisibility);
    };
  }, []);

  const OfferChapter = ({ chapter, totalChapters }) => {
    /**
     * @type {IOfferChapter}
     */
    const offerChapter = { ...IOfferChapter, ...chapter };

    const expanded = expandedChapters?.some(
      (chapterId) => chapterId === offerChapter?.capitulo_id
    );

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openChangePositionDialog, setOpenChangePositionDialog] =
      useState(false);

    const toggleChapter = () => {
      if (expanded) {
        setExpandedChapters([]);
        setExpandedPartidas([]);
        return;
      }

      expandSingleItem(setExpandedChapters, offerChapter?.capitulo_id);
      setExpandedPartidas([]);
    };

    // Añadido para filtrar las partidas por la categoría del capítulo 28/01/2026



    const filteredPartidasForSelectedChapter = React.useMemo(() => {
      const chapterCategoryId = selectedChapter?.partida_categoria?.id;
      if (!chapterCategoryId) return [];

      const categoryIds = new Set([String(chapterCategoryId).toLowerCase()]);
      let hasNewDescendants = true;

      // Un capítulo padre muestra también las plantillas de sus subcategorías.
      while (hasNewDescendants) {
        hasNewDescendants = false;
        (partidaCategories || []).forEach((category) => {
          const parentId = category?.categoria_padre_id;
          const categoryId = category?.id;
          if (
            parentId &&
            categoryId &&
            categoryIds.has(String(parentId).toLowerCase()) &&
            !categoryIds.has(String(categoryId).toLowerCase())
          ) {
            categoryIds.add(String(categoryId).toLowerCase());
            hasNewDescendants = true;
          }
        });
      }

      return (partidas || []).filter((p) => {
        const partidaCategoryIds = p?.categorias?.length
          ? p.categorias.map((category) => category?.id)
          : [p?.categoria?.id];

        const belongsToChapter = partidaCategoryIds.some((categoryId) =>
          categoryIds.has(String(categoryId || "").toLowerCase())
        );
        if (!belongsToChapter) return false;

        return isAvailableToOfferCustomer(p, offerHeader?.cliente_id);
      }).sort((left, right) => {
        const leftSpecific = isSpecificToOfferCustomer(left, offerHeader?.cliente_id) ? 0 : 1;
        const rightSpecific = isSpecificToOfferCustomer(right, offerHeader?.cliente_id) ? 0 : 1;
        return leftSpecific - rightSpecific || String(left?.referencia || "").localeCompare(String(right?.referencia || ""));
      });
    }, [partidas, partidaCategories, selectedChapter, offerHeader?.cliente_id]);

    async function handleChangeChapterPosition(newOrdinal) {
      setLoading(true);

      try {
        const res = await reorderOfferChapter(
          offerChapter?.capitulo_id,
          {
            oferta_id: offerChapter?.oferta_id,
            revision_num: offerChapter?.revision_num,
            new_ordinal: newOrdinal,
          },
          loggedUser?.accessToken
        );

        if (res.status === 200 && res.data) {
          alertSuccess({
            title: "¡Actualizada!",
            customMessage: "La posición del capítulo se ha actualizado con éxito.",
          });
          setOfferHeader(res.data);
          setOpenChangePositionDialog(false);
        }
      } catch (error) {
        alertError({
          error,
          customMessage: "No se ha podido cambiar la posición del capítulo.",
        });
      } finally {
        setLoading(false);
      }
    }

    return (
      <>
        <div className="bg-primary text-white p-3 my-1">
          <div className="d-flex justify-content-between align-items-center">
            <div
              className={`d-flex align-items-${expanded ? "start" : "center"}`}
            >
              {expanded ? (
                <ExpandLess
                  style={{ cursor: "pointer" }}
                  htmlColor="white"
                  onClick={toggleChapter}
                />
              ) : (
                <ExpandMore
                  style={{ cursor: "pointer" }}
                  htmlColor="white"
                  onClick={toggleChapter}
                />
              )}
              <div className="ml-2">
                <strong
                  role="button"
                  tabIndex={0}
                  style={{ cursor: "pointer" }}
                  onClick={toggleChapter}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      toggleChapter();
                    }
                  }}
                >
                  {`CAPÍTULO ${offerChapter?.ordinal}: "${getOfferChapterTitle(offerChapter)}" - ${offerChapter?.partida_categoria?.descripcion || "Sin categoría"}`}
                </strong>
                <Button
                  style={{
                    fontSize: "10px",
                    color: "#FFFFFF",
                    borderColor: "#FFFFFF",
                  }}
                  onClick={() => {
                    setOpenChangePositionDialog(true);
                  }}
                  className="ml-3 p-2"
                  variant="outlined"
                >
                  Cambiar posición
                </Button>
                {expanded && (
                  <div>PARTIDAS: {offerChapter?.partidas?.length}</div>
                )}
              </div>
            </div>
            <div className="text-right">
              {!isOfferManager && <div className="mb-1">
                <strong>TOTAL: {offerChapter?.total_precio} €</strong>
                <div style={{ fontSize: "12px", color: "#FFFFFF" }}>
                  FINAL: {getFinalAmount(offerChapter?.total_precio_final, offerChapter?.total_precio)} €
                </div>
              </div>}
              <Button
                onClick={async () => {
                  clearPageParam();
                  try {
                    const resHeader = await getOfferHeadersById(
                      offerChapter.oferta_id,
                      loggedUser?.accessToken
                    );
                    if (resHeader.status === 200) {
                      setDataCabecerasRevisionTable(resHeader.data);
                    }
                  } catch (error) {
                    alertError({
                      error: error,
                      customMessage: "No se han podido obtener las ofertas.",
                    });
                  }
                  try {
                    const resChapter = await getOfferChaptersById(
                      offerChapter.capitulo_id,
                      loggedUser?.accessToken
                    );
                    if (resChapter.status === 200) {
                      setDataCapitulosRevisionTable(resChapter.data);
                    }
                  } catch (error) {
                    alertError({
                      error: error,
                      customMessage: "No se han podido obtener los capitulos.",
                    });
                  }
                  try {
                    const resPartidas = await getOfferPartidasById(
                      offerChapter.oferta_id,
                      loggedUser?.accessToken
                    );
                    if (resPartidas.status === 200) {
                      setDataPartidaRevisionTable(resPartidas.data);
                    }
                  } catch (error) {
                    alertError({
                      error: error,
                      customMessage: "No se han podido obtener las partidas.",
                    });
                  }
                  setSelectedChapter(offerChapter);
                  setOpenPartidaRevisionTableDialog(true);
                }}
                style={{
                  fontSize: "10px",
                  marginRight: "0.75rem",
                }}
                className="p-2"
                variant="contained"
                color="default"
              >
                Recuperar partida
              </Button>
              <Button
                onClick={() => {
                  setChapterToEdit(offerChapter);
                  setOpenPartidaCategoryDialog(true);
                }}
                style={{ fontSize: "10px", marginRight: "0.75rem" }}
                className="p-2"
                variant="contained"
                color="default"
              >
                Editar capítulo
              </Button>
              <Button
                onClick={() => {
                  clearPageParam();
                  setSelectedChapter(offerChapter);
                  setOpenPartidaTableDialog(true);
                }}
                style={{ fontSize: "10px" }}
                className="p-2"
                variant="contained"
                color="default"
              >
                Nueva partida
              </Button>
              <Button
                style={{ fontSize: "10px" }}
                onClick={() => setOpenConfirmDialog(true)}
                className="ml-3 p-2 bg-danger text-white"
                variant="outlined"
                color="default"
              >
                Eliminar capítulo
              </Button>
            </div>
          </div>
        </div>
        {expanded && (
          <>
            {offerChapter?.partidas?.map((partida, index) => {
              return (
                <div
                  key={"partida-" + index}
                  className="my-2 p-3"
                  style={{ border: "1px solid black" }}
                >
                  <OfferPartida
                    partida={partida}
                    chapterOrder={offerChapter.ordinal}
                    totalPartidas={offerChapter?.partidas?.length || 0}
                  />
                </div>
              );
            })}
          </>
        )}
        <PartidaTableDialog
          open={openPartidaTableDialog}
          setOpen={setOpenPartidaTableDialog}
          //data={partidas}
          title={`Partidas - ${getOfferChapterTitle(selectedChapter)}`}
          data={filteredPartidasForSelectedChapter}
          rootCategory={selectedChapter?.partida_categoria}
          categories={partidaCategories}
          defaultCustomerId={
            customers.some(
              (customer) =>
                customer?.id === offerHeader?.cliente_id &&
                customer?.activo &&
                customer?.usar_partidas_especificas
            )
              ? offerHeader?.cliente_id
              : null
          }

          onSelect={(selectedPartidaId) => {
            let saveOfferPartida = {
              oferta_id: offerHeader?.id,
              revision_num: offerHeader?.revision_num,
              capitulo_id: selectedChapter?.capitulo_id,
              plantilla_partida_original_id: selectedPartidaId,
              def_mano_de_obra_subcontrata_coste:
                offerHeader.def_coste_hora_subcontrata,
            };

            setLoading(true);

            postOfferPartida(saveOfferPartida, loggedUser?.accessToken)
              .then((res) => {
                if (res.status === 201 && res.data?.partida_id) {
                  expandSingleItem(
                    setExpandedPartidas,
                    res.data?.partida_id
                  );
                  expandSingleItem(
                    setExpandedChapters,
                    res.data?.capitulo_id
                  );
                  setLoading(false);
                  setNewlyInsertedPartida(res.data);
                } else {
                  throw new Error("La API no ha devuelto la partida creada.");
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "No se ha podido guardar la partida",
                });
                setLoading(false);
              });
          }}
        />
        <PartidaRevisionTableDialog
          open={openPartidaRevisionTableDialog}
          setOpen={setOpenPartidaRevisionTableDialog}
          cabeceras={dataCabecerasRevisionTable}
          partidas={dataPartidaRevisionTable}
          capitulos={dataCapitulosRevisionTable}
          partidasCategorias={partidaCategories}
          onSelect={(selectedPartida) => {
            let listaPartidas = [
              selectedPartida,
              {
                oferta_id: offerHeader?.id,
                revision_num: offerHeader?.revision_num,
                capitulo_id: selectedChapter?.capitulo_id,
              },
            ];

            setLoading(true);

            postOfferPartidaRevision(
              selectedPartida.partida_id,
              listaPartidas,
              loggedUser?.accessToken
            )
              .then((res) => {
                if (res.status === 201) {
                  alertSuccess({
                    title: "¡Guardada!",
                    customMessage: "Partida guardada con éxito",
                  });
                  expandSingleItem(
                    setExpandedPartidas,
                    res.data?.partida_id
                  );
                  expandSingleItem(
                    setExpandedChapters,
                    res.data?.capitulo_id
                  );
                  handleGetOfferHeader(
                    offerHeader?.id,
                    offerHeader?.revision_num
                  );
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "No se ha podido guardar la partida",
                });
                setLoading(false);
              });
          }}
        />
        <ConfirmDialog
          title={`¿Estás seguro de que quieres eliminar este capítulo?`}
          children={
            "Se eliminarán también todas sus partidas y productos asociados"
          }
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            setLoading(true);
            deleteOfferChapter(
              offerChapter?.capitulo_id,
              loggedUser?.accessToken
            )
              .then((res) => {
                if (res.status === 204) {
                  alertSuccess({
                    title: "¡Eliminado!",
                    customMessage: "Capítulo eliminado con éxito",
                  });
                  handleGetOfferHeader(
                    offerHeader?.id,
                    offerHeader?.revision_num
                  );
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "No se ha podido eliminar el capítulo",
                });
                setLoading(false);
              });
          }}
        />
        <ChangeOfferPartidaPositionDialog
          title="Cambiar posición"
          open={openChangePositionDialog}
          setOpen={setOpenChangePositionDialog}
          currentPosition={offerChapter?.ordinal ?? 0}
          totalPositions={totalChapters}
          onSave={handleChangeChapterPosition}
        />
      </>
    );
  };

  const OfferPartida = ({ partida, chapterOrder, totalPartidas }) => {
    /**
     * @type {IOfferPartida}
     */
    const offerPartida = { ...IOfferPartida, ...partida };

    const expanded = expandedPartidas?.some(
      (partidaId) => partidaId === offerPartida?.partida_id
    );

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openEditPartidaDialog, setOpenEditPartidaDialog] = useState(false);
    const [openChangePositionDialog, setOpenChangePositionDialog] =
      useState(false);
    const [materialGroupUnitDrafts, setMaterialGroupUnitDrafts] = useState({});
    const [updatingMaterialGroupId, setUpdatingMaterialGroupId] = useState(null);
    const savingMaterialGroupIdsRef = useRef(new Set());
    const [openImportPartidaDialog, setOpenImportPartidaDialog] = useState(false);
    const [templatePartidaToImport, setTemplatePartidaToImport] = useState(null);

    const rootCategory = React.useMemo(() => {
      const category = (partidaCategories || []).find(
        (item) => item?.id === offerPartida?.categoria_id
      );
      if (!category) return null;

      return category.categoria_padre_id
        ? (partidaCategories || []).find(
            (item) => item?.id === category.categoria_padre_id
          ) || category
        : category;
    }, [offerPartida?.categoria_id, partidaCategories]);

    const importablePartidas = React.useMemo(() => {
      if (!rootCategory?.id) return [];

      const categoryIds = new Set([String(rootCategory.id).toLowerCase()]);
      let foundDescendants = true;
      while (foundDescendants) {
        foundDescendants = false;
        (partidaCategories || []).forEach((category) => {
          const categoryId = category?.id;
          if (
            category?.categoria_padre_id &&
            categoryId &&
            categoryIds.has(String(category.categoria_padre_id).toLowerCase()) &&
            !categoryIds.has(String(categoryId).toLowerCase())
          ) {
            categoryIds.add(String(categoryId).toLowerCase());
            foundDescendants = true;
          }
        });
      }

      return (partidas || [])
        .filter((template) => {
          const templateCategoryIds = template?.categorias?.length
            ? template.categorias.map((category) => category?.id)
            : [template?.categoria?.id];
          const belongsToCategory = templateCategoryIds.some((categoryId) =>
            categoryIds.has(String(categoryId || "").toLowerCase())
          );
          if (!belongsToCategory) return false;
          return isAvailableToOfferCustomer(template, offerHeader?.cliente_id);
        })
        .sort((left, right) => {
          const leftSpecific = isSpecificToOfferCustomer(left, offerHeader?.cliente_id) ? 0 : 1;
          const rightSpecific = isSpecificToOfferCustomer(right, offerHeader?.cliente_id) ? 0 : 1;
          return leftSpecific - rightSpecific || String(left?.referencia || "").localeCompare(String(right?.referencia || ""));
        });
    }, [rootCategory, partidaCategories, partidas, offerHeader?.cliente_id]);

    async function handleImportDecomposition(sustituir) {
      if (!templatePartidaToImport?.id) return;

      setLoading(true);
      try {
        await importOfferPartidaDecomposition(
          offerPartida.partida_id,
          {
            oferta_id: offerPartida.oferta_id,
            revision_num: offerPartida.revision_num,
            capitulo_id: offerPartida.capitulo_id,
            plantilla_partida_original_id: templatePartidaToImport.id,
            sustituir,
          },
          loggedUser?.accessToken
        );
        setTemplatePartidaToImport(null);
        alertSuccess({
          title: "¡Descompuesto importado!",
          customMessage: sustituir
            ? "Se ha sustituido el descompuesto de la partida."
            : "El descompuesto se ha añadido al final de la partida.",
        });
        handleGetOfferHeader(offerHeader.id, offerHeader.revision_num);
      } catch (error) {
        setTemplatePartidaToImport(null);
        alertError({
          error,
          customMessage: "No se ha podido importar el descompuesto.",
        });
        setLoading(false);
      }
    }

    async function handleSelectTemplateForImport(partidaId) {
      setLoading(true);
      try {
        const response = await getPartidaById(partidaId, loggedUser?.accessToken);
        const template = response?.data;
        const hasProducts = Boolean(template?.productos?.length);
        const hasGroupProducts = Boolean(
          template?.agrupaciones_materiales?.some(
            (group) => group?.productos?.length
          )
        );

        if (!hasProducts && !hasGroupProducts) {
          alertError({
            error: "La partida seleccionada no tiene descompuesto.",
            customMessage: "La partida seleccionada no tiene descompuesto.",
          });
          setLoading(false);
          return;
        }

        const selectedTemplate = (importablePartidas || []).find(
          (templateItem) => templateItem?.id === partidaId
        );
        setTemplatePartidaToImport(selectedTemplate || { id: partidaId });
      } catch (error) {
        alertError({
          error,
          customMessage: "No se ha podido comprobar el descompuesto de la partida.",
        });
      } finally {
        setLoading(false);
      }
    }

    async function handleAddOfferProducts(selectedProductIds) {
      const ids = Array.isArray(selectedProductIds)
        ? selectedProductIds
        : [selectedProductIds];

      const existingTemplateProductIds = new Set(
        (selectedPartida?.productos || []).map(
          (product) => product?.plantilla_producto_original_id
        )
      );

      const productIdsToAdd = ids.filter(
        (productId) => productId && !existingTemplateProductIds.has(productId)
      );

      if (!productIdsToAdd.length) {
        return;
      }

      setLoading(true);

      const createdProductIds = [];

      for (const productId of productIdsToAdd) {
        const saveOfferProduct = {
          oferta_id: offerHeader?.id,
          revision_num: offerHeader?.revision_num,
          capitulo_id: selectedPartida?.capitulo_id,
          partida_id: selectedPartida?.partida_id,
          plantilla_producto_original_id: productId,
        };

        try {
          const res = await postOfferProduct(
            saveOfferProduct,
            loggedUser?.accessToken
          );

          if (res.status === 201 && res.data?.producto_id) {
            createdProductIds.push(res.data.producto_id);
          }
        } catch (error) {
          alertError({
            error,
            customMessage: "No se ha podido guardar el producto",
          });
          setLoading(false);
          return;
        }
      }

      if (createdProductIds.length) {
        alertSuccess({
          title: "¡Guardado!",
          customMessage:
            createdProductIds.length === 1
              ? "Producto guardado con éxito"
              : "Productos guardados con éxito",
        });

        setExpandedProducts((prevExpandedProducts) =>
          (prevExpandedProducts || []).filter(
            (productId) => !createdProductIds.includes(productId)
          )
        );

        handleGetOfferHeader(offerHeader?.id, offerHeader?.revision_num);
      } else {
        setLoading(false);
      }
    }

    async function handleAddOfferMaterialGroups(selectedGroupIds) {
      const ids = Array.isArray(selectedGroupIds) ? selectedGroupIds : [selectedGroupIds];
      if (!selectedPartida?.partida_id) return;
      setLoading(true);
      try {
        for (const groupId of ids) {
          await postOfferMaterialGroup({ oferta_id: offerHeader.id, revision_num: offerHeader.revision_num, capitulo_id: selectedPartida.capitulo_id, partida_id: selectedPartida.partida_id, agrupacion_material_id: groupId, unidades: 1 }, loggedUser?.accessToken);
        }
        alertSuccess({ title: "¡Guardado!", customMessage: ids.length === 1 ? "Agrupación añadida con éxito." : "Agrupaciones añadidas con éxito." });
        handleGetOfferHeader(offerHeader.id, offerHeader.revision_num);
      } catch (error) {
        alertError({ error, customMessage: "No se ha podido añadir la agrupación." });
        setLoading(false);
      }
    }

    async function handleDeleteOfferMaterialGroup(group) {
      setLoading(true);
      try {
        await deleteOfferMaterialGroup(group.id, loggedUser?.accessToken);
        handleGetOfferHeader(offerHeader.id, offerHeader.revision_num);
      } catch (error) { alertError({ error, customMessage: "No se ha podido eliminar la agrupación." }); setLoading(false); }
    }

    async function handleUpdateOfferMaterialGroupUnits(group, unidades) {
      if (savingMaterialGroupIdsRef.current.size > 0) return;
      const quantity = Number(String(unidades ?? "").trim().replace(",", "."));
      if (!Number.isFinite(quantity) || quantity < 0.01) {
        setMaterialGroupUnitDrafts((current) => ({ ...current, [group.id]: group.unidades }));
        return;
      }
      if (quantity === Number(group.unidades)) {
        setMaterialGroupUnitDrafts((current) => ({ ...current, [group.id]: quantity }));
        return;
      }
      savingMaterialGroupIdsRef.current.add(group.id);
      setUpdatingMaterialGroupId(group.id);
      try {
        await updateOfferMaterialGroup(group.id, { unidades: quantity }, loggedUser?.accessToken);
        setMaterialGroupUnitDrafts((current) => {
          const next = { ...current };
          delete next[group.id];
          return next;
        });
        handleGetOfferHeader(offerHeader.id, offerHeader.revision_num, { preserveDetail: true });
      }
      catch (error) {
        alertError({ error, customMessage: "No se ha podido actualizar la agrupación." });
        setMaterialGroupUnitDrafts((current) => ({ ...current, [group.id]: group.unidades }));
      } finally {
        savingMaterialGroupIdsRef.current.delete(group.id);
        setUpdatingMaterialGroupId(null);
      }
    }

    async function handleUpdateOriginalPartida() {
      if (!offerPartida?.plantilla_partida_original_id) {
        alertError({
          error: "La partida no tiene plantilla original asociada.",
        });
        return;
      }

      setLoading(true);

      let updateError;
      try {
        const templatePartidaResponse = await getPartidaById(
          offerPartida.plantilla_partida_original_id,
          loggedUser?.accessToken
        );

        if (templatePartidaResponse.status !== 200 || !templatePartidaResponse.data) {
          throw new Error("No se ha podido obtener la plantilla original de la partida.");
        }

        const templatePartida = templatePartidaResponse.data;
        const directProducts = offerPartida?.productos || [];
        const materialGroups = offerPartida?.agrupaciones_materiales || [];
        if (
          directProducts.some((product) => !product?.plantilla_producto_original_id) ||
          materialGroups.some((group) =>
            !group?.agrupacion_material_original_id ||
            !(group.productos || []).length ||
            group.productos.some((product) => !product?.plantilla_producto_original_id)
          )
        ) {
          throw new Error("El descompuesto contiene referencias originales incompletas. No se ha modificado la plantilla.");
        }
        const partidaPayload = {
          referencia: templatePartida?.referencia ?? "",
          descripcion: templatePartida?.descripcion ?? "",
          categoria_id:
            templatePartida?.categoria?.id ?? templatePartida?.categoria_id ?? null,
          categoria_ids:
            templatePartida?.categoria_ids ??
            templatePartida?.categorias?.map((category) => category.id) ??
            [templatePartida?.categoria?.id ?? templatePartida?.categoria_id].filter(Boolean),
          concepto: templatePartida?.concepto ?? "",
          cliente_id: templatePartida?.cliente_id ?? null,
          productos: directProducts.map((product) => ({
            producto_id: product?.plantilla_producto_original_id,
            unidades: product?.def_unidades ?? 1,
          })),
          agrupaciones_materiales: materialGroups.map((group) => ({
            agrupacion_material_original_id: group.agrupacion_material_original_id,
            referencia: group.referencia,
            descripcion: group.descripcion,
            tipo_unidad_id: group.tipo_unidad_id,
            unidades: group.unidades,
            ordinal: group.ordinal,
            productos: (group.productos || []).map((product, ordinal) => ({ producto_id: product.plantilla_producto_original_id, unidades: product.def_unidades / (group.unidades || 1), ordinal })),
          })),
        };

        await updatePartida(
          offerPartida.plantilla_partida_original_id,
          partidaPayload,
          loggedUser?.accessToken
        );

        for (const product of offerPartida?.productos || []) {
          if (!product?.plantilla_producto_original_id) {
            continue;
          }

          await updateProductOriginal(
            product?.producto_id,
            product,
            loggedUser?.accessToken
          );
        }

      } catch (error) {
        updateError = error;
      } finally {
        setLoading(false);
      }
      if (updateError) {
        alertError({ error: updateError, customMessage: "No se ha podido actualizar la partida original." });
        return;
      }
      alertSuccess({
        title: "¡Actualizada!",
        customMessage: "La partida original se ha actualizado con éxito.",
      });
    }

    async function handleChangePartidaPosition(newOrdinal) {
      setLoading(true);

      try {
        const res = await reorderOfferPartida(
          offerPartida?.partida_id,
          {
            oferta_id: offerPartida?.oferta_id,
            revision_num: offerPartida?.revision_num,
            capitulo_id: offerPartida?.capitulo_id,
            new_ordinal: newOrdinal,
          },
          loggedUser?.accessToken
        );

        if (res.status === 200 && res.data) {
          alertSuccess({
            title: "¡Actualizada!",
            customMessage: "La posición de la partida se ha actualizado con éxito.",
          });
          setOfferHeader(res.data);
          setOpenChangePositionDialog(false);
        }
      } catch (error) {
        alertError({
          error,
          customMessage: "No se ha podido cambiar la posición de la partida.",
        });
      } finally {
        setLoading(false);
      }
    }

    return (
      <>
        <div className="d-flex flex-column">
          <div className="d-flex align-items-center col-12 px-0">
            {expanded ? (
              <ExpandLess
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setExpandedPartidas([]);
                }}
              />
            ) : (
              <>
                <div className="d-flex justify-content-center col-12 px-0">
                  <ExpandMore
                    className="mr-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      expandSingleItem(
                        setExpandedPartidas,
                        offerPartida?.partida_id
                      );
                    }}
                  />
                  <table
                    className="table table-bordered w-100"
                    style={{ tableLayout: "auto" }}
                  >
                    <thead>
                      <tr>
                        <th className="p-2">Pos.</th>
                        <th className="p-2">Ud.</th>
                        <th className="p-2">Descripción</th>
                        <th className="p-2">Med.</th>
                        {isOfferManager ? (
                          <th className="p-2">Coste</th>
                        ) : (
                          <>
                            <th className="p-2">Precio</th>
                            <th className="p-2">Total</th>
                          </>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="p-2">{`${chapterOrder}.${offerPartida.ordinal}`}</td>
                        <td className="p-2">{offerPartida?.tipo_unidad}</td>
                        <td className="p-2">{offerPartida?.descripcion}</td>
                        <td className="p-2">{offerPartida?.unidades}</td>
                        {isOfferManager ? (
                          <td className="p-2 text-right">
                            {formatCurrencyDisplay(
                              (offerPartida?.mano_de_obra_coste || 0) +
                                (offerPartida?.subcontrata_coste || 0) +
                                (offerPartida?.materiales_coste || 0)
                            )}
                          </td>
                        ) : (
                          <>
                            <td className="p-2 text-right">
                              <div>{formatCurrencyDisplay(offerPartida?.precio_unitario)}</div>
                              <div style={{ fontSize: "12px" }}>
                                Final: {formatCurrencyDisplay(getFinalAmount(offerPartida?.precio_unitario_final, offerPartida?.precio_unitario))}
                              </div>
                            </td>
                            <td className="p-2 text-right">
                              <div>{formatCurrencyDisplay(offerPartida?.precio_total)}</div>
                              <div style={{ fontSize: "12px" }}>
                                Final: {formatCurrencyDisplay(getFinalAmount(offerPartida?.precio_total_final, offerPartida?.precio_total))}
                              </div>
                            </td>
                          </>
                        )}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
          <div className="d-flex justify-content-between align-items-center col-12 px-0">
            <div style={{ marginLeft: expanded ? 0 : "42px" }}>
              {!expanded && (
                <Button
                  style={{ fontSize: "10px" }}
                  onClick={() => {
                    setOpenChangePositionDialog(true);
                  }}
                  className="p-2"
                  variant="outlined"
                  color="default"
                >
                  Cambiar posición
                </Button>
              )}
            </div>
            <div className="d-flex justify-content-end align-items-center">
              {offerPartidaTypeFormatter(
                offerPartida.def_tipo_impotacion_partida
              )}
              <Button
                onClick={() => {
                  setGuardarPlantillaPartida(offerPartida);
                  setOpenGuardarPlantillaPartidaDialog(true);
                }}
                style={{ fontSize: "10px" }}
                className="p-2"
                variant="contained"
                color="default"
              >
                Guardar como nueva partida
              </Button>
              <Button
                onClick={handleUpdateOriginalPartida}
                style={{ fontSize: "10px" }}
                className="ml-3 p-2"
                variant="contained"
                color="default"
              >
                Actualizar partida original
              </Button>
              <Button
                style={{ fontSize: "10px" }}
                onClick={() => {
                  setOpenEditPartidaDialog(true);
                }}
                className="ml-3 p-2"
                variant="outlined"
                color="default"
              >
                Editar partida
              </Button>
              <Button
                style={{ fontSize: "10px" }}
                onClick={() => {
                  setOpenConfirmDialog(true);
                }}
                className="ml-3 p-2 bg-danger text-white"
                variant="outlined"
                color="default"
              >
                Eliminar partida
              </Button>
            </div>
          </div>
        </div>
        {expanded && (
          <>
            <div className="row d-flex align-items-center">
              <div className="col-md-6">
                <TextField
                  label="Descripción"
                  value={offerPartida?.descripcion}
                  onChange={() => { }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-6">
                <TextField
                  label="Referencia"
                  value={offerPartida?.referencia}
                  onChange={() => { }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
            </div>
            <div className="mb-1 ml-3" style={{ fontSize: "11px" }}>
              Concepto
            </div>
            <div
              style={{
                color: "#212121",
                fontSize: "15px",
                padding: "10px",
                border: "1px solid #c4c4c4",
                borderRadius: "0.42rem",
              }}
              dangerouslySetInnerHTML={{
                __html: offerPartida?.concepto,
              }}
            />
            <div className="row d-flex justify-content-end">
              <div className="col-md-2">
                <strong>Tiempos</strong>
                <TextField
                  label="Unitario"
                  disabled={offerPartida.def_tipo_impotacion_partida > 1}
                  value={
                    formatInstallationTime(
                      offerPartida?.tiempo_total / offerPartida.unidades
                    ) + " h"
                  }
                  onChange={() => { }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="Total"
                  disabled={offerPartida.def_tipo_impotacion_partida > 1}
                  value={
                    formatInstallationTime(offerPartida?.tiempo_total) + " h"
                  }
                  onChange={() => { }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-2">
                <strong>Mano de obra Interna</strong>
                <TextField
                  label="Coste"
                  disabled={offerPartida.def_tipo_impotacion_partida > 0}
                  value={offerPartida.mano_de_obra_coste + " €"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                {!isOfferManager && <TextField
                  label="PVP"
                  disabled={offerPartida.def_tipo_impotacion_partida > 0}
                  value={offerPartida.mano_de_obra_venta + " €"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
                {!isOfferManager && <TextField
                  label="Margen venta"
                  disabled={offerPartida.def_tipo_impotacion_partida > 0}
                  value={
                    (Number(offerPartida.mano_de_obra_venta) - Number(offerPartida.mano_de_obra_coste))
                      .toFixed(2) + " €"
                  }
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                  margin="normal"
                  variant="outlined"
                />}


              </div>
              <div className="col-md-2">
                <strong>Subcontrata</strong>
                <TextField
                  label="Coste"
                  disabled={offerPartida.def_tipo_impotacion_partida !== 1}
                  value={
                    offerPartida.def_tipo_impotacion_partida !== 2
                      ? offerPartida.subcontrata_coste + " €"
                      : "0 €"
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                {!isOfferManager && <TextField
                  label="PVP"
                  disabled={offerPartida.def_tipo_impotacion_partida !== 1}
                  value={
                    offerPartida.def_tipo_impotacion_partida !== 2
                      ? offerPartida.subcontrata_venta + " €"
                      : "0 €"
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
                {!isOfferManager && <TextField
                  label="Margen venta"
                  disabled={offerPartida.def_tipo_impotacion_partida !== 1}
                  value={
                    (
                      offerPartida.def_tipo_impotacion_partida !== 2
                        ? (Number(offerPartida.subcontrata_venta) - Number(offerPartida.subcontrata_coste))
                        : 0
                    ).toFixed(2) + " €"
                  }
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                  margin="normal"
                  variant="outlined"
                />}
                {!isOfferManager && offerPartida.def_tipo_impotacion_partida > 0 && (
                  <TextField
                    label="Incremento subcontrata"
                    value={
                      (offerPartida.incremento_margen_subcontrata ?? 0) + "%"
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                )}

                {offerPartida?.def_tipo_impotacion_partida === 1 && (
                  <TextField
                    label="Coste Mano de obra"
                    value={
                      offerPartida.def_mano_de_obra_subcontrata_coste + " €"
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                )}
              </div>
              <div className="col-md-2">
                <strong>Materiales</strong>
                <TextField
                  label="Coste"
                  disabled={offerPartida.def_tipo_impotacion_partida > 1}
                  value={offerPartida.materiales_coste + " €"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                {!isOfferManager && <TextField
                  label="PVP"
                  disabled={offerPartida.def_tipo_impotacion_partida > 1}
                  value={offerPartida.materiales_venta + " €"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
                {!isOfferManager && <TextField
                  label="Margen venta"
                  disabled={offerPartida.def_tipo_impotacion_partida > 1}
                  value={
                    (Number(offerPartida.materiales_venta) - Number(offerPartida.materiales_coste))
                      .toFixed(2) + " €"
                  }
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                  margin="normal"
                  variant="outlined"
                />}


              </div>
              <div className="col-md-4">
                <strong>Total</strong>
                <TextField
                  label="Coste"
                  value={
                    (
                      offerPartida.def_tipo_impotacion_partida === 2
                        ? calc_total_costes(
                          offerPartida.mano_de_obra_coste,
                          Number(offerPartida.subcontrata_coste) *
                          Number(offerPartida.unidades),
                          offerPartida.materiales_coste
                        )
                        : calc_total_costes(
                          offerPartida.mano_de_obra_coste,
                          offerPartida.subcontrata_coste,
                          offerPartida.materiales_coste
                        )
                    ).toFixed(2) + " €"
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                {!isOfferManager && <TextField
                  label="PVP"
                  value={offerPartida.precio_total + " €"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
                {!isOfferManager && <TextField
                  label="PVP final"
                  value={getFinalAmount(offerPartida.precio_total_final, offerPartida.precio_total) + " €"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
                {!isOfferManager && <TextField
                  label="Margen venta"
                  value={
                    Number(
                      offerPartida.precio_total -
                        (
                          offerPartida.def_tipo_impotacion_partida === 2
                            ? calc_total_costes(
                              offerPartida.mano_de_obra_coste,
                              Number(offerPartida.subcontrata_coste) *
                                Number(offerPartida.unidades),
                              offerPartida.materiales_coste
                            )
                            : calc_total_costes(
                              offerPartida.mano_de_obra_coste,
                              offerPartida.subcontrata_coste,
                              offerPartida.materiales_coste
                            )
                        )
                    ).toFixed(2) +
                    " €"
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
              </div>
            </div>
            <hr />
            <div className="row d-flex justify-content-end">
              <div className="col-md-2">
                <TextField
                  label="Tipo de unidades"
                  value={offerPartida?.tipo_unidad}
                  onChange={() => { }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-2">
                <TextField
                  label="Unidades"
                  value={offerPartida?.unidades}
                  onChange={() => { }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              {!isOfferManager && <div className="col-md-2">
                <TextField
                  label="pvp unitario"
                  value={offerPartida?.precio_unitario + " €"}
                  onChange={() => { }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="pvp unitario final"
                  value={getFinalAmount(offerPartida?.precio_unitario_final, offerPartida?.precio_unitario) + " €"}
                  onChange={() => { }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>}
              {!isOfferManager && <div className="col-md-2">
                <TextField
                  label="pvp total"
                  value={offerPartida?.precio_total + " €"}
                  onChange={() => { }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="pvp total final"
                  value={getFinalAmount(offerPartida?.precio_total_final, offerPartida?.precio_total) + " €"}
                  onChange={() => { }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>}
            </div>
            {offerPartida?.def_tipo_impotacion_partida <= 1 && (
              <>
                <div className="bg-primary text-white p-3 my-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <strong>DESCOMPUESTO</strong>
                    <div className="d-flex align-items-center">
                      <Button
                        className="p-2 mr-2"
                        style={{ fontSize: "10px" }}
                        onClick={() => {
                          setSelectedPartida(offerPartida);
                          setOpenProductTableDialog(true);
                        }}
                        variant="contained"
                        color="default"
                      >
                        Añadir producto
                      </Button>
                      <Button
                        className="p-2 mr-2"
                        style={{ fontSize: "10px" }}
                        onClick={() => {
                          setSelectedPartida(offerPartida);
                          setOpenMaterialGroupDialog(true);
                        }}
                        variant="contained"
                        color="default"
                      >
                        Añadir agrupación
                      </Button>
                      <Button
                        className="p-2"
                        style={{ fontSize: "10px" }}
                        onClick={() => setOpenImportPartidaDialog(true)}
                        variant="contained"
                        color="default"
                      >
                        Importar descompuesto
                      </Button>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    backgroundColor: "rgb(237 242 255)",
                    border: "1px solid #dbe5ff",
                    borderTop: "none",
                    borderRadius: "0 0 0.42rem 0.42rem",
                    padding: "8px 10px 12px",
                  }}
                >
                  {offerPartida?.productos?.map((product, index) => {
                    const isSubcontrataMixta =
                      Number(offerPartida?.def_tipo_impotacion_partida) === 1;
                    return (
                      <div key={"product-" + index}>
                        <OfferProduct
                          product={product}
                          isSubcontrataMixta={isSubcontrataMixta}
                          productIndex={index}
                          totalProducts={offerPartida?.productos?.length || 0}
                        />
                      </div>
                    );
                  })}
                  {(offerPartida?.agrupaciones_materiales || []).map((group) => (
                    <div key={group.id} className="mt-3 p-3" style={{ background: "#e8f7ff", borderLeft: "4px solid #3699ff" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <strong>AGRUPACIÓN: {group.descripcion}</strong>
                        <div className="d-flex align-items-center">
                          <TextField
                            type="text"
                            label="Cantidad"
                            value={materialGroupUnitDrafts[group.id] ?? group.unidades}
                            disabled={updatingMaterialGroupId !== null}
                            onChange={(event) => {
                              const value = event.target.value;
                              setMaterialGroupUnitDrafts((current) => ({ ...current, [group.id]: value }));
                            }}
                            onBlur={(event) => handleUpdateOfferMaterialGroupUnits(group, event.target.value)}
                            onKeyDown={(event) => {
                              if (event.key === "Enter" && !event.nativeEvent.isComposing) {
                                event.preventDefault();
                                event.stopPropagation();
                                handleUpdateOfferMaterialGroupUnits(group, event.target.value);
                              }
                            }}
                            style={{ width: "110px" }}
                            inputProps={{ inputMode: "decimal", min: 0.01, step: 0.01 }}
                          />
                          {updatingMaterialGroupId === group.id && <CircularProgress size={18} className="ml-2" />}
                          <Button color="secondary" className="ml-2" onClick={() => handleDeleteOfferMaterialGroup(group)}>Eliminar</Button>
                        </div>
                      </div>
                      {(group.productos || []).map((product, index) => <div key={product.producto_id} className="mt-2"><OfferProduct product={product} isSubcontrataMixta={Number(offerPartida?.def_tipo_impotacion_partida) === 1} productIndex={index} totalProducts={group.productos.length} /></div>)}
                    </div>
                  ))}
                </div>
              </>
            )}
          </>
        )}
        <ConfirmDialog
          title={`¿Estás seguro de que quieres eliminar esta partida?`}
          children={"Se eliminarán también todos sus productos asociados"}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            setLoading(true);
            deleteOfferPartida(offerPartida.partida_id, loggedUser?.accessToken)
              .then((res) => {
                if (res.status === 204) {
                  alertSuccess({
                    title: "¡Eliminada!",
                    customMessage: "Partida eliminada con éxito",
                  });
                  handleGetOfferHeader(
                    offerHeader?.id,
                    offerHeader?.revision_num
                  );
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "No se ha podido eliminar la partida",
                });
                setLoading(false);
              });
          }}
        />
        <ProductSelectTableDialog
          title="Productos"
          open={openProductTableDialog}
          setOpen={setOpenProductTableDialog}
          data={products?.filter(
            (x) =>
              !selectedPartida?.productos?.some(
                (y) => y?.plantilla_producto_original_id === x?.id
              )
          )}
          initialSelectedProducts={[]}
          productMarcas={productMarcas}
          productFamilies={productFamilies}
          productTypes={productTypes}
          onSave={handleAddOfferProducts}
          allowCreateProduct
        />
        <MaterialGroupSelectDialog title="Añadir agrupaciones" open={openMaterialGroupDialog} setOpen={setOpenMaterialGroupDialog} data={materialGroups} onSave={handleAddOfferMaterialGroups} />
        <PartidaTableDialog
          title={`Importar descompuesto - ${rootCategory?.descripcion || "Partidas"}`}
          open={openImportPartidaDialog}
          setOpen={setOpenImportPartidaDialog}
          data={importablePartidas}
          rootCategory={rootCategory}
          categories={partidaCategories}
          defaultCustomerId={offerHeader?.cliente_id}
          onSelect={handleSelectTemplateForImport}
        />
        <Dialog
          open={Boolean(templatePartidaToImport)}
          onClose={() => setTemplatePartidaToImport(null)}
          aria-labelledby="import-decomposition-dialog"
        >
          <DialogTitle id="import-decomposition-dialog">Importar descompuesto</DialogTitle>
          <DialogContent>
            ¿Quieres sustituir el descompuesto actual o añadir el de la partida seleccionada al final?
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={() => setTemplatePartidaToImport(null)}>
              Cancelar
            </Button>
            <Button variant="outlined" color="primary" onClick={() => handleImportDecomposition(false)}>
              Añadir al final
            </Button>
            <Button variant="contained" color="secondary" onClick={() => handleImportDecomposition(true)}>
              Sustituir
            </Button>
          </DialogActions>
        </Dialog>
        <ChangeOfferPartidaPositionDialog
          title="Cambiar posición"
          open={openChangePositionDialog}
          setOpen={setOpenChangePositionDialog}
          currentPosition={offerPartida?.ordinal ?? 0}
          totalPositions={totalPartidas}
          onSave={handleChangePartidaPosition}
        />
        <EditOfferPartidaDialog
          title="Editar partida"
          open={openEditPartidaDialog}
          setOpen={setOpenEditPartidaDialog}
          productTypes={productTypes}
          data={partida}
          onSave={() =>
            handleGetOfferHeader(
              offerPartida?.oferta_id,
              offerPartida?.revision_num
            )
          }
        />

      </>
    );
  };

  const OfferProduct = ({
    product,
    isSubcontrataMixta,
    productIndex,
    totalProducts,
  }) => {
    /**
     * @type {IOfferProduct}
     */
    const offerProduct = { ...IOfferProduct, ...product };
    const displayProduct = normalizeOfferProductFlags(offerProduct, isSubcontrataMixta);

    const expanded =
      expandedProducts?.some(
        (productId) => productId === offerProduct?.producto_id
      );

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openEditProductDialog, setOpenEditProductDialog] = useState(false);
    const [openChangeMultiplicableDialog, setOpenChangeMultiplicableDialog] =
      useState(false);
    const [openChangeTimeDialog, setOpenChangeTimeDialog] = useState(false);
    const [openChangeUnitsDialog, setOpenChangeUnitsDialog] = useState(false);
    async function handleMoveProduct(direction) {
      setLoading(true);

      try {
        const res = await reorderOfferProduct(
          offerProduct?.producto_id,
          { direction },
          loggedUser?.accessToken
        );

        if (res.status === 200) {
          updateOfferPartidaInState(res.data);
        }
      } catch (error) {
        alertError({
          error,
          customMessage: "No se ha podido reordenar el producto.",
        });
      } finally {
        setLoading(false);
      }
    }

    return (
      <>
        <div className="d-flex align-items-center mt-2">
          {expanded ? (
            <ExpandLess
              style={{ cursor: "pointer" }}
              onClick={() => {
                setExpandedProducts(
                  expandedProducts?.filter(
                    (productId) => productId !== offerProduct?.producto_id
                  )
                );
              }}
            />
          ) : (
            <>
              <ExpandMore
                className="mr-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setExpandedProducts(expandedProducts?.concat(offerProduct?.producto_id));
                }}
              />


              <div
                className="d-flex align-items-center"
                style={{ width: "100%", gap: "12px", flexWrap: "nowrap", minWidth: 0 }}
              >
                <div
                  style={{
                    fontWeight: 500,
                    flex: "1 1 auto",
                    minWidth: 0,
                    maxWidth: "40%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  title={offerProduct?.descripcion ?? ""}
                >
                  {offerProduct?.descripcion}
                </div>

                <div
                  className="d-flex align-items-center"
                  style={{ gap: "10px", flexShrink: 0, marginLeft: "auto" }}
                >
                  <TextField
                    label="Unidades"
                    value={offerProduct?.def_unidades ?? ""}
                    onChange={() => { }}
                    onClick={() => setOpenChangeUnitsDialog(true)}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    style={{ width: 120, cursor: "pointer" }}
                  />

                  {isOfferManager && <TextField
                    label="Tiempo ud."
                    value={formatInstallationTime(offerProduct?.def_tiempo_mano_de_obra) + " h"}
                    onChange={() => { }}
                    onClick={() => setOpenChangeTimeDialog(true)}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    style={{ width: 120, cursor: "pointer" }}
                  />}

                  {isOfferManager && <TextField
                    label="Tiempo total"
                    value={formatInstallationTime(offerProduct?.def_tiempo_mano_de_obra * offerProduct?.def_unidades) + " h"}
                    onChange={() => { }}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    style={{ width: 120 }}
                  />}

                  <TextField
                    label="Total Coste"
                    value={(offerProduct?.calc_total_coste ?? 0) + " €"}
                    onChange={() => { }}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    style={{ width: 140 }}
                  />

                  {!isOfferManager && <TextField
                    label="Total PVP"
                    value={(offerProduct?.calc_total_venta ?? 0) + " €"}
                    onChange={() => { }}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    style={{ width: 140 }}
                  />}
                  {!isOfferManager && <TextField
                    label="Total final"
                    value={getFinalAmount(offerProduct?.calc_total_venta_final, offerProduct?.calc_total_venta) + " €"}
                    onChange={() => { }}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    style={{ width: 140 }}
                  />}

                  {!isOfferManager && <TextField
                    label="Margen venta"
                    value={
                      (
                        Number(offerProduct?.calc_total_venta ?? 0) -
                        Number(offerProduct?.calc_total_coste ?? 0)
                      ).toFixed(2) + " €"
                    }
                    onChange={() => { }}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    style={{ width: 160 }}
                  />}

                  <div
                    onClick={() => setOpenChangeMultiplicableDialog(true)}
                    style={{
                      marginLeft: 8,
                      marginRight: 0,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <FormControlLabel
                      style={{ marginLeft: 0, marginRight: 0, pointerEvents: "none" }}
                      control={
                        <Checkbox
                          checked={offerProduct?.multiplicable ?? true}
                          disabled
                          color="primary"
                        />
                      }
                      label="Mult."
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: 8,
                      minWidth: 64,
                    }}
                  >
                    <div
                      style={{
                        width: 32,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {productIndex > 0 && (
                        <Button
                          onClick={() => handleMoveProduct("UP")}
                          size="small"
                          style={{
                            minWidth: "auto",
                            padding: "6px 4px",
                            border: "none",
                            background: "transparent",
                          }}
                        >
                          <KeyboardArrowUp fontSize="small" />
                        </Button>
                      )}
                    </div>
                    <div
                      style={{
                        width: 32,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {productIndex < totalProducts - 1 && (
                        <Button
                          onClick={() => handleMoveProduct("DOWN")}
                          size="small"
                          style={{
                            minWidth: "auto",
                            padding: "6px 4px",
                            border: "none",
                            background: "transparent",
                          }}
                        >
                          <KeyboardArrowDown fontSize="small" />
                        </Button>
                      )}
                    </div>
                  </div>
                  <Tooltip title="Eliminar producto">
                    <Button
                      onClick={() => {
                        setOpenConfirmDialog(true);
                      }}
                      color="secondary"
                      size="small"
                      style={{
                        minWidth: "auto",
                        padding: "6px 4px",
                        marginLeft: 16,
                        border: "none",
                        background: "transparent",
                      }}
                    >
                      <DeleteOutline fontSize="small" htmlColor="#F64E60" />
                    </Button>
                  </Tooltip>
                </div>
              </div>


            </>
          )}
          <hr className="ml-2" style={{ flex: 1 }} />
        </div>
        {expanded && (
          <>
            <div className="row">
              <div className="col-12 d-flex justify-content-end mb-3">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={offerProduct?.multiplicable ?? true}
                      disabled
                      color="primary"
                    />
                  }
                  label="Multiplicable"
                />
                <Button
                  onClick={async () => {
                    setLoading(true);
                    try {
                      const response = await updateProductOriginal(
                        displayProduct?.producto_id,
                        displayProduct,
                        loggedUser?.accessToken
                      );
                      if (response.status >= 200 && response.status < 300) {
                        alertSuccess({
                          title: "¡Actualizado!",
                          customMessage: "Producto actualizado con éxito",
                        });
                      }
                    } catch (error) {
                      alertError({
                        error,
                        customMessage: "No se ha podido actualizar el producto",
                      });
                    } finally {
                      setLoading(false);
                    }
                  }}
                  style={{ fontSize: "10px" }}
                  className="p-2"
                  variant="contained"
                >
                  Actualizar producto original
                </Button>
                <Button
                  style={{ fontSize: "10px" }}
                  onClick={() => setOpenEditProductDialog(true)}
                  className="ml-3 p-2"
                  variant="outlined"
                  color="default"
                >
                  Editar producto
                </Button>
                {!isOfferManager && <Button
                  style={{ fontSize: "10px" }}
                  onClick={() => setOpenConfirmDialog(true)}
                  className="ml-3 p-2 bg-danger text-white"
                  variant="outlined"
                  color="default"
                >
                  Eliminar producto
                </Button>}
              </div>
              <div className="col-12 row mb-4">
                <div className="col-md-4">
                  <TextField
                    label="Producto"
                    value={offerProduct?.descripcion}
                    onChange={() => { }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div>
                <div className="col-md-2">
                  <TextField
                    label="Referencia"
                    value={offerProduct?.referencia}
                    onChange={() => { }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div>
                <div className="col-md-2">
                  <TextField
                    label="Unidades"
                    value={offerProduct?.def_unidades}
                    onChange={() => { }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div>
                <div className="col-md-2">
                  <TextField
                    label="Factor"
                    value={offerProduct?.def_factor}
                    onChange={() => { }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div>
                <div className="col-md-2">
                  <TextField
                    label="Total"
                    value={offerProduct?.calc_total_coste + " €"}
                    onChange={() => { }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div>
                {/* <div className="col-md-1">
                  <TextField
                    label="Descuento proveedor"
                    value={offerProduct?.def_descuento_proveedor + "%"}
                    onChange={() => {}}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div> */}
              </div>
              <div className="col-12 p-3">
                <div className="row justify-content-between">
                  <div className="col-md-2">
                    <strong>Tiempos</strong>
                    <TextField
                      label="Unitario"
                      value={
                        formatInstallationTime(
                          offerProduct?.def_tiempo_mano_de_obra
                        ) + " h"
                      }
                      onChange={() => { }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="Total"
                      value={
                        formatInstallationTime(
                          offerProduct?.def_tiempo_mano_de_obra *
                          offerProduct?.def_unidades
                        ) + " h"
                      }
                      onChange={() => { }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-3">
                    <strong>Mano de obra</strong>
                    <TextField
                      label="Coste"
                      value={offerProduct.calc_mano_de_obra_coste + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    {!isOfferManager && <>
                    <TextField
                      label="PVP"
                      value={offerProduct.calc_mano_de_obra_venta + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="PVP final"
                      value={getFinalAmount(offerProduct.calc_mano_de_obra_venta_final, offerProduct.calc_mano_de_obra_venta) + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="Margen venta"
                      value={
                        Number(
                          offerProduct.calc_mano_de_obra_venta - offerProduct.calc_mano_de_obra_coste
                        ).toFixed(2) + " €"
                      }
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ readOnly: true }}
                      margin="normal"
                      variant="outlined"
                    />
                    </>}
                  </div>
                  <div className="col-md-3">
                    <strong>Materiales</strong>
                    <TextField
                      label="Coste"
                      value={offerProduct.calc_materiales_coste + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    {!isOfferManager && <>
                    <TextField
                      label="PVP"
                      value={offerProduct.calc_materiales_venta + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="PVP final"
                      value={getFinalAmount(offerProduct.calc_materiales_venta_final, offerProduct.calc_materiales_venta) + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="Margen venta"
                      value={
                        Number(
                          offerProduct.calc_materiales_venta - offerProduct.calc_materiales_coste
                        ).toFixed(2) + " €"
                      }
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ readOnly: true }}
                      margin="normal"
                      variant="outlined"
                    />
                    </>}
                    {isSubcontrataMixta && (
                      <FormControlLabel
                        style={{ marginTop: 8 }}
                        control={
                          <Checkbox
                            color="primary"
                            checked={displayProduct?.imputar_tiempo_a_mano_de_obra_interna ?? false}
                            disabled
                          />
                        }
                        label="Imputar tiempo a mano de obra interna"
                      />
                    )}

                  </div>
                  <div className="col-md-4">
                    <strong>Total</strong>
                    <TextField
                      label="Coste"
                      value={offerProduct?.calc_total_coste + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    {!isOfferManager && <>
                    <TextField
                      label="PVP"
                      value={offerProduct.calc_total_venta + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="PVP final"
                      value={getFinalAmount(offerProduct.calc_total_venta_final, offerProduct.calc_total_venta) + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="Margen venta"
                      value={
                        Number(offerProduct.calc_total_venta -
                          offerProduct.calc_total_coste).toFixed(2) +
                        " €"
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    </>}
                    {isSubcontrataMixta && (
                      <FormControlLabel
                        style={{ marginTop: 8 }}
                        control={
                          <Checkbox
                            color="primary"
                            checked={displayProduct?.imputar_material_a_subcontrata ?? false}
                            disabled
                          />
                        }
                        label="Imputar material a subcontrata"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <ConfirmDialog
          title={`¿Estás seguro de que quieres eliminar este producto de la partida de la oferta?`}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            setLoading(true);
            deleteOfferProduct(
              offerProduct?.producto_id,
              loggedUser?.accessToken
            )
              .then((res) => {
                if (res.status === 204) {
                  alertSuccess({
                    title: "¡Eliminado!",
                    customMessage: "Producto eliminado con éxito de la partida",
                  });
                  handleGetOfferHeader(
                    offerHeader?.id,
                    offerHeader?.revision_num
                  );
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage:
                    "No se ha podido eliminar el producto de la partida",
                });
                setLoading(false);
              });
          }}
        />
        <EditOfferProductDialog
          title="Editar producto"
          open={openEditProductDialog}
          setOpen={setOpenEditProductDialog}
          data={displayProduct}
          isSubcontrataMixta={isSubcontrataMixta}
          onSave={(updatedPartida) => {
            if (updatedPartida?.partida_id) {
              updateOfferPartidaInState(updatedPartida);
            } else {
              handleGetOfferHeader(
                offerProduct?.oferta_id,
                offerProduct?.revision_num
              );
            }
          }}
        />
        <ChangeOfferProductUnitsDialog
          title="Cambiar unidades"
          open={openChangeUnitsDialog}
          setOpen={setOpenChangeUnitsDialog}
          data={displayProduct}
          onSave={(updatedPartida) => {
            if (updatedPartida?.partida_id) {
              updateOfferPartidaInState(updatedPartida);
            } else {
              handleGetOfferHeader(
                offerProduct?.oferta_id,
                offerProduct?.revision_num
              );
            }
          }}
        />
        <ChangeOfferProductTimeDialog
          title="Cambiar tiempo unitario"
          open={openChangeTimeDialog}
          setOpen={setOpenChangeTimeDialog}
          data={displayProduct}
          onSave={(updatedPartida) => {
            if (updatedPartida?.partida_id) {
              updateOfferPartidaInState(updatedPartida);
            } else {
              handleGetOfferHeader(
                offerProduct?.oferta_id,
                offerProduct?.revision_num
              );
            }
          }}
        />
        <ChangeOfferProductMultiplicableDialog
          title="Cambiar multiplicable"
          open={openChangeMultiplicableDialog}
          setOpen={setOpenChangeMultiplicableDialog}
          data={displayProduct}
          onSave={(updatedPartida) => {
            if (updatedPartida?.partida_id) {
              updateOfferPartidaInState(updatedPartida);
            } else {
              handleGetOfferHeader(
                offerProduct?.oferta_id,
                offerProduct?.revision_num
              );
            }
          }}
        />
      </>
    );
  };












  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader sticky={false} className="stickyModule" title="Oferta">
            {/* <CardHeaderToolbar>
              <Button
                onClick={() => saveOffer()}
                variant="outlined"
                color="primary"
              >
                Guardar
              </Button>
            </CardHeaderToolbar> */}
          </CardHeader>
          {!isVisible && !isOfferManager && (
            <>
              <div style={styles}>
                <div
                  className="row d-flex align-items-center"
                  style={{ marginBottom: "6px" }}
                >
                  <div className="col-md-3">
                    <strong style={{ fontSize: "16px" }}>Margen</strong>
                  </div>
                  <div className="col-md-3">
                    <TextField
                      label="Material"
                      value={offerHeader.def_margen_material + "%"}
                      onChange={handleChange("def_margen_material")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="none"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-3">
                    <TextField
                      label="Mano de obra"
                      value={offerHeader.def_margen_m_obra + "%"}
                      onChange={handleChange("def_margen_m_obra")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="none"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-3">
                    <TextField
                      label="Subcontrata"
                      value={offerHeader.def_margen_subcontrata + "%"}
                      onChange={handleChange("def_margen_subcontrata")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="none"
                      variant="outlined"
                    />
                  </div>
                </div>
                <div
                  className="row d-flex align-items-center"
                  style={{ marginBottom: "2px" }}
                >
                  <div className="col-md-3">
                    <strong style={{ fontSize: "16px" }}>
                      Recursos internos
                    </strong>
                  </div>
                  <div className="col-md-3">
                    <TextField
                      label="Trabajadores"
                      value={offerHeader.def_trabajadores_asignados}
                      onChange={handleChange("def_trabajadores_asignados")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      type="number"
                      margin="none"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-3">
                    <TextField
                      label="Coste/hora"
                      value={offerHeader.def_coste_hora_m_obra + " €"}
                      onChange={handleChange("def_coste_hora_m_obra")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="none"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-3">
                    <TextField
                      label="Comisiones"
                      value={offerHeader.def_comisiones + "%"}
                      onChange={handleChange("def_comisiones")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="none"
                      variant="outlined"
                    />
                  </div>
                </div>
                <div className="row d-flex justify-content-start ">
                  <div className="col-md-2">
                    <strong>Tiempos</strong>
                    <div className="d-flex flex-row">
                      <TextField
                        label="Jornadas"
                      value={offerHeader.calc_tiempo_jornadas ?? ""}
                        onChange={handleChange("calc_tiempo_jornadas")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="Horas"
                      value={offerHeader.calc_tiempo_horas ?? ""}
                        onChange={handleChange("calc_tiempo_horas")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <strong>Mano de obra</strong>
                    <div className="d-flex flex-row">
                      <TextField
                        label="Coste"
                        value={offerHeader.calc_m_obra_coste + " €"}
                        onChange={handleChange("calc_m_obra_coste")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="PVP"
                        value={offerHeader.calc_m_obra_pvp + " €"}
                        onChange={handleChange("def_trabajadores_asignados")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="PVP final"
                        value={getFinalAmount(offerHeader.calc_m_obra_pvp_final, offerHeader.calc_m_obra_pvp) + " €"}
                        onChange={handleChange("calc_m_obra_pvp_final")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <strong>Subcontrata</strong>
                    <div className="d-flex flex-row">
                      <TextField
                        label="Coste"
                        value={offerHeader.calc_subcontrata_coste + " €"}
                        onChange={handleChange("calc_subcontrata_coste")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="PVP"
                        value={offerHeader.calc_subcontrata_pvp + " €"}
                        onChange={handleChange("calc_subcontrata_pvp")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="PVP final"
                        value={getFinalAmount(offerHeader.calc_subcontrata_pvp_final, offerHeader.calc_subcontrata_pvp) + " €"}
                        onChange={handleChange("calc_subcontrata_pvp_final")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <strong>Materiales</strong>
                    <div className="d-flex flex-row">
                      <TextField
                        label="Coste"
                        value={offerHeader.calc_materiales_coste + " €"}
                        onChange={handleChange("calc_materiales_coste")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="PVP"
                        value={offerHeader.calc_materiales_pvp + " €"}
                        onChange={handleChange("calc_materiales_pvp")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="PVP final"
                        value={getFinalAmount(offerHeader.calc_materiales_pvp_final, offerHeader.calc_materiales_pvp) + " €"}
                        onChange={handleChange("calc_materiales_pvp_final")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <strong>Total</strong>
                    <div className="d-flex flex-row">
                      <TextField
                        label="Coste"
                        value={offerHeader.calc_total_coste + " €"}
                        onChange={handleChange("calc_total_coste")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="PVP"
                        value={offerHeader.calc_total_pvp + " €"}
                        onChange={handleChange("calc_total_pvp")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="PVP final"
                        value={getFinalAmount(offerHeader.calc_total_pvp_final, offerHeader.calc_total_pvp) + " €"}
                        onChange={handleChange("calc_total_pvp_final")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <CardHeader title="Cabecera" sticky={false}>
            <CardHeaderToolbar>
              <div className="d-flex align-items-center w-100">
                <div
                  style={{
                    marginRight: "0.75rem",
                    marginTop: "0.5rem",
                  }}
                >
                  <Button
                    onClick={() => {
                      handleNuevaRevision();
                    }}
                    variant="contained"
                  >
                    Nueva revisión
                  </Button>
                </div>
                <Autocomplete
                  disabled={!offerHeader?.id}
                  style={{ width: "150px" }}
                  id="autocomplete-status"
                  disableClearable
                  options={offerStatus}
                  getOptionLabel={(option) => option?.descripcion || ""}
                  value={
                    offerStatus?.find((x) => x.id === offerHeader?.estado_id) ||
                    null
                  }
                  onChange={(event, selected) => {
                    setLoading(true);
                    updateOfferHeaderStatus(
                      offerHeader?.id,
                      offerHeader?.revision_num,
                      selected?.id,
                      loggedUser?.accessToken
                    )
                      .then((res) => {
                        if (res.status === 204) {
                          alertSuccess({
                            title: "¡Guardado!",
                            customMessage: "Estado actualizado con éxito",
                          });
                          handleGetOfferHeader(
                            offerHeader?.id,
                            offerHeader?.revision_num
                          );
                        }
                      })
                      .catch((error) => {
                        alertError({
                          error: error,
                          customMessage: "No se ha podido cambiar el estado",
                        });
                        setLoading(false);
                      });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Estado"
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
                <Button
                  className="ml-3 btn btn-primary mt-2"
                  onClick={() => {
                    setOpenEditOfferHeaderDialog(true);
                  }}
                  variant="outlined"
                  color="primary"
                >
                  Editar
                </Button>
              </div>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <div className="row d-flex align-items-center">
              <div className="col-md-4">
                <TextField
                  label="Número de oferta"
                  value={offerHeader.num_oferta ?? ""}
                  onChange={handleChange("num_oferta")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
              <div className="col-md-4">
                <Autocomplete
                  id="autocomplete-cliente"
                  disablePortal
                  disableClearable
                  options={customers}
                  getOptionLabel={(option) => option?.nombre || ""}
                  value={
                    customers?.find((x) => x.id === offerHeader?.cliente_id) ||
                    null
                  }
                  onChange={(event, selected) => {
                    setOfferHeader({
                      ...offerHeader,
                      cliente_id: selected?.id || null,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Cliente"
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      required
                    />
                  )}
                />
              </div>
              <div className="col-md-4">
                <TextField
                  label="Localización"
                  value={offerHeader.localizacion ?? ""}
                  onChange={handleChange("localizacion")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
            </div>
            <div className="row d-flex align-items-center">
              <div className="col-md-4">
                <TextField
                  id={`reference`}
                  label="Referencia de obra"
                  value={offerHeader.referencia ?? ""}
                  onChange={handleChange("referencia")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
              <div className="col-md-4">
                <TextField
                  id={`revision`}
                  label="Revisión"
                  value={offerHeader.revision_num}
                  onChange={handleChange("revision_num")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
              <div className="col-md-4">
                <div className="d-flex justify-content-end">
                  {offerStatusFormatter(
                    offerStatus?.find((x) => x.id === offerHeader?.estado_id)
                  )}
                  <Button
                    className="ml-3"
                    onClick={async () => {
                      const objOferta = { ...offerHeader };
                      objOferta.cliente_nombre =
                        customers?.find((x) => x.id === offerHeader?.cliente_id)
                          .nombre || "";
                      await generatePDF(objOferta);
                    }}
                    variant="outlined"
                    color="primary"
                  >
                    Descargar
                  </Button>

                  <Button
                    className="ml-3"
                    onClick={() => {
                      const objOferta = { ...offerHeader };
                      objOferta.cliente_nombre =
                        customers?.find((x) => x.id === offerHeader?.cliente_id)?.nombre || "";
                      generateExcel(objOferta);
                    }}
                    variant="outlined"
                    color="primary"
                  >
                    EXCEL
                  </Button>
                </div>
              </div>
            </div>
            <hr />
            {!isOfferManager && <div className="row d-flex align-items-center">
              <div className="col-md-3">
                <strong>Margen</strong>
              </div>
              <div className="col-md-3">
                <TextField
                  label="Material"
                  value={offerHeader.def_margen_material + "%"}
                  onChange={handleChange("def_margen_material")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-3">
                <TextField
                  label="Mano de obra"
                  value={offerHeader.def_margen_m_obra + "%"}
                  onChange={handleChange("def_margen_m_obra")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-3">
                <TextField
                  label="Subcontrata"
                  value={offerHeader.def_margen_subcontrata + "%"}
                  onChange={handleChange("def_margen_subcontrata")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
            </div>}
            <hr />
            <div ref={divRef} className="row d-flex align-items-center">
              <div className="col-md-3">
                <strong>Recursos internos</strong>
              </div>
              <div className="col-md-3">
                <TextField
                  label="Trabajadores"
                  value={offerHeader.def_trabajadores_asignados}
                  onChange={handleChange("def_trabajadores_asignados")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  type="number"
                  margin="normal"
                  variant="outlined"
                />
              </div>
              {!isOfferManager && <div className="col-md-3">
                <TextField
                  label="Coste/hora"
                  value={offerHeader.def_coste_hora_m_obra + " €"}
                  onChange={handleChange("def_coste_hora_m_obra")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>}
              {!isOfferManager && <div className="col-md-3">
                <TextField
                  label="Comisiones"
                  value={offerHeader.def_comisiones + "%"}
                  onChange={handleChange("def_comisiones")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>}
            </div>
            <hr />
            <div className="row d-flex align-items-center mt-2">
              <div className="col-md-2">
                <strong>Tiempos</strong>
                <TextField
                  label="Jornadas"
                  value={offerHeader.calc_tiempo_jornadas ?? ""}
                  onChange={handleChange("calc_tiempo_jornadas")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="Horas"
                  value={offerHeader.calc_tiempo_horas ?? ""}
                  onChange={handleChange("calc_tiempo_horas")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-2">
                <strong>Mano de obra</strong>
                <TextField
                  label="Coste"
                  value={offerHeader.calc_m_obra_coste + " €"}
                  onChange={handleChange("calc_m_obra_coste")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                {!isOfferManager && <TextField
                  label="PVP"
                  value={offerHeader.calc_m_obra_pvp + " €"}
                  onChange={handleChange("def_trabajadores_asignados")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
                {!isOfferManager && <TextField
                  label="PVP final"
                  value={getFinalAmount(offerHeader.calc_m_obra_pvp_final, offerHeader.calc_m_obra_pvp) + " €"}
                  onChange={handleChange("calc_m_obra_pvp_final")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
              </div>
              <div className="col-md-2">
                <strong>Subcontrata</strong>
                <TextField
                  label="Coste"
                  value={offerHeader.calc_subcontrata_coste + " €"}
                  onChange={handleChange("calc_subcontrata_coste")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                {!isOfferManager && <TextField
                  label="PVP"
                  value={offerHeader.calc_subcontrata_pvp + " €"}
                  onChange={handleChange("calc_subcontrata_pvp")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
                {!isOfferManager && <TextField
                  label="PVP final"
                  value={getFinalAmount(offerHeader.calc_subcontrata_pvp_final, offerHeader.calc_subcontrata_pvp) + " €"}
                  onChange={handleChange("calc_subcontrata_pvp_final")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
              </div>
              <div className="col-md-2">
                <strong>Materiales</strong>
                <TextField
                  label="Coste"
                  value={offerHeader.calc_materiales_coste + " €"}
                  onChange={handleChange("calc_materiales_coste")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                {!isOfferManager && <TextField
                  label="PVP"
                  value={offerHeader.calc_materiales_pvp + " €"}
                  onChange={handleChange("calc_materiales_pvp")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
                {!isOfferManager && <TextField
                  label="PVP final"
                  value={getFinalAmount(offerHeader.calc_materiales_pvp_final, offerHeader.calc_materiales_pvp) + " €"}
                  onChange={handleChange("calc_materiales_pvp_final")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
              </div>
              <div className="col-md-4">
                <strong>Total</strong>
                <TextField
                  label="Coste"
                  value={offerHeader.calc_total_coste + " €"}
                  onChange={handleChange("calc_total_coste")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                {!isOfferManager && <TextField
                  label="PVP"
                  value={offerHeader.calc_total_pvp + " €"}
                  onChange={handleChange("calc_total_pvp")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
                {!isOfferManager && <TextField
                  label="PVP final"
                  value={getFinalAmount(offerHeader.calc_total_pvp_final, offerHeader.calc_total_pvp) + " €"}
                  onChange={handleChange("calc_total_pvp_final")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />}
              </div>
            </div>
          </CardBody>
          {(offerHeaderId || offerHeader?.id) && (
            <>
              <CardHeader
                title={
                  <>
                    Detalle
                    {isDetailLoading && (
                      <span className="d-inline-flex align-items-center ml-3" style={{ fontSize: "13px", fontWeight: 400 }}>
                        <CircularProgress size={16} className="mr-2" />
                        Cargando capítulos...
                      </span>
                    )}
                  </>
                }
                sticky={false}
              >
                <CardHeaderToolbar>
                  <Button
                    className="ml-3 btn btn-primary"
                    onClick={() => {
                      setChapterToEdit(null);
                      setOpenPartidaCategoryDialog(true);
                    }}
                    variant="outlined"
                    color="primary"
                    disabled={isDetailLoading}
                  >
                    Nuevo capítulo
                  </Button>
                </CardHeaderToolbar>
              </CardHeader>
              <CardBody>
                {isDetailLoading ? (
                  <div className="d-flex align-items-center py-4 text-muted">
                    <CircularProgress size={20} className="mr-3" />
                    Cargando capítulos y partidas...
                  </div>
                ) : (
                  offerHeader?.capitulos?.map((chapter) => {
                    return (
                      <OfferChapter
                        key={chapter?.capitulo_id || chapter?.id}
                        chapter={chapter}
                        totalChapters={offerHeader?.capitulos?.length || 0}
                      />
                    );
                  })
                )}
              </CardBody>
            </>
          )}
        </Card>
        <Button
          onClick={handleBack}
          variant="outlined"
          style={{ marginRight: "20px" }}
        >
          Atrás
        </Button>
        {/* <Button onClick={() => saveOffer()} variant="outlined" color="primary">
          Guardar
        </Button> */}
        <EditOfferHeaderDialog
          title="Cabecera"
          open={openEditOfferHeaderDialog}
          setOpen={setOpenEditOfferHeaderDialog}
          customers={customers}
          iva={ivas}
          data={offerHeader}
          onSave={(offerHeaderData) => {
            handleGetOfferHeader(
              offerHeaderData?.id,
              offerHeaderData?.revision_num
            );
          }}
        />
        <OfferChapterDialog
          open={openPartidaCategoryDialog}
          setOpen={setOpenPartidaCategoryDialog}
          categories={partidaCategories}
          chapter={chapterToEdit}
          onSave={(chapterData) => {
            setLoading(true);
            const isEditing = Boolean(chapterToEdit?.capitulo_id);
            const request = isEditing
              ? updateOfferChapter(
                chapterToEdit.capitulo_id,
                {
                  oferta_id: chapterToEdit.oferta_id,
                  revision_num: chapterToEdit.revision_num,
                  ...chapterData,
                },
                loggedUser?.accessToken
              )
              : postOfferChapter(
                {
                  oferta_id: offerHeader?.id,
                  revision_num: offerHeader?.revision_num,
                  ...chapterData,
                },
                loggedUser?.accessToken
              );

            request
              .then((res) => {
                if (res.status === 201 || res.status === 204) {
                  alertSuccess({
                    title: "¡Guardado!",
                    customMessage: isEditing
                      ? "Capítulo actualizado con éxito"
                      : "Capítulo creado con éxito",
                  });
                  if (!isEditing) {
                    expandSingleItem(
                      setExpandedChapters,
                      res.data?.capitulo_id
                    );
                  }
                  setExpandedPartidas([]);
                  setOpenPartidaCategoryDialog(false);
                  setChapterToEdit(null);
                  handleGetOfferHeader(
                    offerHeader?.id,
                    offerHeader?.revision_num
                  );
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: isEditing
                    ? "No se ha podido actualizar el capítulo"
                    : "No se ha podido crear el capítulo",
                });
              })
              .finally(() => setLoading(false));
          }}
        />

        {openGuardarPlantillaPartidaDialog && guardarPlantillaPartida && (
          <GuardarPlantillaPartidaDialog
            title="Guardar Plantilla Partida"
            open={openGuardarPlantillaPartidaDialog}
            setOpen={setOpenGuardarPlantillaPartidaDialog}
            data={guardarPlantillaPartida}
            defaultCustomerId={
              customers.some(
                (customer) =>
                  customer?.id === offerHeader?.cliente_id &&
                  customer?.activo &&
                  customer?.usar_partidas_especificas
              )
                ? offerHeader?.cliente_id
                : null
            }
            onSave={handleSaveAsNewOriginalPartida}
          />
        )}
        <EditOfferPartidaDialog
          title="Completar partida"
          open={Boolean(newlyInsertedPartida)}
          setOpen={(nextOpen) => {
            if (!nextOpen) {
              setNewlyInsertedPartida(null);
              handleGetOfferHeader(offerHeader?.id, offerHeader?.revision_num, {
                preserveDetail: true,
              });
            }
          }}
          productTypes={productTypes}
          data={newlyInsertedPartida || {}}
        />
        <LoadingDialog open={loading} />
      </>
    );
}

